import { createContext, useContext } from "react";

import { DragData } from "./DropZoneDnd.types";

interface DocumentDndContextValue {
  activeDrag: DragData | null;
  isMoving: boolean;
}

const defaultValue: DocumentDndContextValue = {
  activeDrag: null,
  isMoving: false,
};

export const DocumentDndContext = createContext(defaultValue);
export const useDocumentDndContext = (): DocumentDndContextValue => useContext(DocumentDndContext);
